'use strict';

import { Project } from '../../app/resources/project/project.interface';

(function () {
  angular
    .module('specsguardApp')
    .controller('ProjectCtrl', ProjectCtrl);

  ProjectCtrl.$inject = ['$scope', '$location', 'Auth', 'Project', 'projects',
    'ProjectDataservice', 'Constants', 'Labels', '$filter', 'sg2ModalService'];

  function ProjectCtrl ($scope, $location, Auth, Project, projects, ProjectDataservice,
    Constants, Labels, $filter, sg2ModalService) {

    /* Forward projects page to V2 projects page. */
    window.location.href = 'v2/projects';

    const vm = this;

    vm.LABELS = Labels;
    vm.userRole = Auth.getCurrentUserRole();
    vm.showDeleteButton = Auth.getUserAccessLevel() >= 8;
    vm.projects = projects;
    vm.currentUser = Auth.getCurrentUser();
    vm.constants = Constants.getList('QUALITY_LEVELS');

    vm.canAddProject = vm.currentUser.role !== 'project associate';

    vm.config = {
      activeTab: 'active'
    };

    $scope.$on('projectSocket:projectListUpdated', () => {
      ProjectDataservice.getProjectList().then((projectlist) => updateProjects(projectlist));
    });

    vm.switchView = (tab) => {
      vm.config.activeTab = tab;
      updateProjects();
    };

    // Project model modifications
    const getManagers = function () {
      let projectManagersFromAllProjects = [];

      vm.displayedProjects.forEach((proj) => {
        proj.projectManagers = [];

        // Add each manager to the project.
        // Afterwards the array should be rendred to text
        proj.users.forEach((user) => {
          if (user.active && user.projectRole === 'manager') {
            if (user.userId) {
              projectManagersFromAllProjects.push(user.userId);
              proj.projectManagers.push(user.userId.fullName);
            } else {
              console.error(`Project user ( ${user._id} ) does not exists anymore. ( project ${proj.name} )`);
            }
          }
        });
        proj.projectManagersDisplay = proj.projectManagers.join(', ');
      });

      vm.projectManagersFromAllProjects = Array.from(new Set(projectManagersFromAllProjects));

    };

    const updateProjects = (projectlist = vm.projects) => {
      vm.projects = angular.fromJson(angular.toJson(projectlist));

      vm.projects = vm.projects.map(function (proj) {
        proj.qualityLevelDisplayName = vm.constants.find((ql) =>
          ql.value === proj.qualityLevel).displayName;
        return proj;
      });

      vm.displayedProjects = getDisplayedProjects(vm.config.activeTab === 'archived');
      getManagers();
    };

    function getDisplayedProjects (archived) {
      return vm.projects.filter((project) => {
        if (project.archived === archived && project.active) {
          // Always show the date in a readable way.
          if (Auth.getUserAccessLevel() >= 7) {
            return true;
          }

          const userID = Auth.getCurrentUser()._id;
          let projectHasUser = false;
          project.users.forEach(function (user) {
            if ((Auth.getUserAccessLevel() < 7 && user.active) && user.userId._id === userID) {
              projectHasUser = true;
            }
          });


          if (projectHasUser) {
            return true;
          }
        }

        return false;
      });
    }

    updateProjects(projects);

    vm.canCreateNewProject = function () {
      return (Auth.getUserAccessLevel() >= 3);
    };

    /**
     * If the user doesn't have the proper accesslevel we will display a warning message.
     * @param id Project Id
     */
    vm.open = function (id) {
      window.location.href = '/v2/project/' + id + '/dashboard';
    };

    /**
     * We need to be able to highlight which project is accessable, no matter the userAccesLevel
     * @param project string containing the project id
     * @param userId user id string
     */
    vm.userInProject = (projectId: string, userId: string) => {
      const selectedProject: Project = vm.displayedProjects.find(proj => proj._id === projectId);
      return selectedProject.users.some(user => user.userId._id === userId);
    };

    // clickhander is being rendered through the sg-table-directive
    vm.clickHandler = (index, projectId) => {

      // Only check for the accessLevel if the currentUser isn't part of the project-team
      if (Auth.getUserAccessLevel() === 7 ) {
        if (!vm.userInProject(projectId, vm.currentUser._id)) {
          sg2ModalService.confirm({
            title: vm.LABELS.getLabel('insufficientaccessrights'),
            content: vm.LABELS.getLabel('insufficientprojectrights'),
            disableClose: true,
          });

          return;
        }
      }

      vm.open(projectId); // reusing the vm.open() to redirect to the projects page.
    };

    vm.addProject = () => $location.path('/project/new');

    vm.remove = function (projectId) {
      Project.deactivateProject({id: projectId}).$promise
        .then(function () {
          vm.projects = vm.projects.filter((p) => p._id !== projectId );
        });
    };

    vm.filterProjectManager = (column, project) =>
      column.filterData.some((item) => item.selected && project.projectManagers.includes(item.fullName));

    function getProjectDate (id, item, column) {
      if (angular.isDefined(item)) {
        return item['readable' + column.displayKey + 'Date'] =
          angular.isDefined(item[column.displayKey]) ? $filter('sgDateAgo')(item[column.displayKey]) : '';
      }
      return item;
    }

    // tableColumns is used to dislay the displayProjects in a filter table.
    // CombineFilters param is set to true
    vm.tableColumns = [{
      headerTitle: vm.LABELS.getLabel('number'),
      type: 'string',
      sortable: true,
      displayKey: 'number',
      columnClickHandler: vm.clickHandler,
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('name'),
      type: 'string',
      sortable: true,
      displayKey: 'name',
      columnClickHandler: vm.clickHandler,
      tdClass: 'sg-mat-table__cell--projects-name', // needed to define a proper width on the table cell
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('client'),
      type: 'string',
      sortable: true,
      displayKey: 'clientName',
      columnClickHandler: vm.clickHandler,
      tdClass: 'sg-mat-table__cell--clientname', // needed to define a proper width on the table cell
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('level'),
      type: 'radio',
      sortable: true,
      filterData: vm.constants,
      optionDisplayKey: 'displayName',
      optionValueKey: 'displayName',
      displayKey: 'qualityLevelDisplayName',
      columnClickHandler: vm.clickHandler,
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('projectmanager'),
      type: 'multiSelect',
      sortable: true,
      filterData: vm.projectManagersFromAllProjects,
      optionDisplayKey: 'fullName',
      optionValueKey: 'fullName',
      displayKey: 'projectManagersDisplay',
      columnClickHandler: vm.clickHandler,
      customFilter: vm.filterProjectManager,
      tdClass: 'sg-mat-table__cell--fullname', // needed to define a proper width on the table cell
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('dateadded'),
      type: 'date',
      sortable: true,
      displayKey: 'created',
      displayKeyFn: getProjectDate,
      tdClass: 'sg-mat-table__cell--created-date sg-mat-table__cell--timestamp', // needed to define a proper width on the table cell
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('dateupdated'),
      type: 'date',
      sortable: true,
      displayKey: 'updated',
      displayKeyFn: getProjectDate,
      columnClickHandler: vm.clickHandler,
      tdClass: 'sg-mat-table__cell--updated-date sg-mat-table__cell--timestamp', // needed to define a proper width on the table cell
      columnFilter: true,
    }];

    vm.tablePagination = {
      resultLimitDropdown: {
        enabled: true,
        limit: [10, 20, 50, 100, 250]
      },
      resultLimit: 10
    };

    // this should be always be enabled to use the filter menu
    vm.columnFilters = {
      enabled: true,
    };

  }

})();
